import { useState } from "react";

import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { changeMyPassword, updateMyProfile } from "../../../api/user";
import WhiteBox from "../../../components/WhiteBox";
import { Button, Col2Grid, Input, Label, Title } from "../../main-styles";
import * as S from "./styles";
import { updateUser } from "../../../redux/slices/authSlice";

function Perfil() {
  const dispatch = useDispatch();
  const { authReducer } = useSelector((state) => state);
  const { user } = authReducer;
  const [state, setState] = useState({
    nome: user.name || "",
    email: user.email || "",
    phone: user.phone || "",
    password: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const { nome, email, phone, password, newPassword, confirmNewPassword } =
    state;

  window.document.title = `Organnact`;

  function updateState(target, value) {
    setState((prevState) => ({
      ...prevState,
      [target]: value,
    }));
  }

  function validate() {
    const promises = [];
    if (newPassword.length > 0) {
      if (password === "") {
        toast.error("A senha atual é obrigatória");
        return false;
      }
      if (newPassword !== confirmNewPassword) {
        toast.error("As senhas não conferem");
        return false;
      }
      if (newPassword.length < 6) {
        toast.error("A nova senha deve ter pelo menos 6 caracteres");
        return false;
      }

      // salva a senha

      toast.promise(changeMyPassword(password, newPassword), {
        loading: "Alterando senha...",
        success: (data) => {
          console.log("data", data);
          return "Senha alterada com sucesso!";
        },
        error: (error) => {
          console.error("Error changing password:", error);
          switch (error.response?.data?.message) {
            case "Current password is incorrect":
              return `A senha atual está incorreta`;
            default:
              return `Erro ao alterar senha: ${
                error.response?.data?.message || error.message
              }`;
          }
        },
      });
    }
    // checa se o nome ou email foram alterados
    console.log("user", user);
    console.log("nome", nome);
    console.log("email", email);
    console.log("phone", phone);
    if (nome !== user.name || email !== user.email || phone !== user.phone) {
      if (phone.length !== 11) {
        toast.error("O telefone deve ter 11 dígitos (419XXXXXXXX)");
        return false;
      }
      toast.promise(updateMyProfile(nome, email, phone), {
        loading: "Atualizando perfil...",
        success: (data) => {
          console.log("data", data);
          dispatch(updateUser({ name: nome, email, phone }));
          return "Perfil atualizado com sucesso!";
        },
        error: (error) => {
          console.error("Error updating profile:", error);
          switch (error.response?.data?.message) {
            case "Email already exists":
              return `O email ${email} já está cadastrado`;
            default:
              return `Erro ao atualizar perfil: ${
                error.response?.data?.message || error.message
              }`;
          }
        },
      });
    }
  }

  return (
    <S.Container>
      <Col2Grid>
        <div>
          <Title style={{ marginTop: 20 }}>Perfil</Title>
          <WhiteBox style={{ height: "auto" }}>
            <Label>Nome</Label>
            <Input
              value={nome}
              onChange={(e) => updateState("nome", e.target.value)}
            />
            <Label>Email</Label>

            <Input
              value={email}
              onChange={(e) => updateState("email", e.target.value)}
            />
            <Label>Telefone / Whatsapp (419XXXXXXXX)</Label>

            <Input
              maxLength={11}
              value={phone}
              onChange={(e) => {
                // only numbers
                const value = e.target.value.replace(/\D/g, "");
                updateState("phone", value);
              }}
            />
          </WhiteBox>
        </div>
        <div>
          <Title style={{ marginTop: 20 }}>Alterar Senha</Title>
          <WhiteBox style={{ height: "auto" }}>
            <Label>Senha atual</Label>
            <Input
              type="password"
              value={password}
              onChange={(e) => updateState("password", e.target.value)}
            />
            <Label>Nova senha</Label>
            <Input
              type="password"
              value={newPassword}
              onChange={(e) => updateState("newPassword", e.target.value)}
            />
            <Label>Repetir nova senha</Label>
            <Input
              type="password"
              value={confirmNewPassword}
              onChange={(e) =>
                updateState("confirmNewPassword", e.target.value)
              }
            />
            <Button onClick={validate}>Salvar</Button>
          </WhiteBox>
        </div>
      </Col2Grid>
    </S.Container>
  );
}

export default Perfil;
